<template>
    <modal @close="$emit('close')" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{$t('account.indirizzo_fatturazione')}}</h5>
        </div>
        <div slot="body">
            <form>
                <div class="alert alert-danger" v-if="this.errors.length">
                    <ul v-for="error in this.errors">
                        <li>{{error}}</li>
                    </ul>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-3 mr-5 ml-5 pl-5 pr-5"
                     v-if="this.locale.f_fat_obbligatoria">
                    <mcw-radio
                        id="billing-type-azienda"
                        v-model="billing_type"
                        :label="this.$t('azienda')"
                        name="billing_type"
                        value="AZIENDA"
                    />
                    <mcw-radio
                        id="billing-type-privato"
                        v-model="billing_type"
                        :label="this.$t('privato')"
                        name="billing_type"
                        value="PRIVATO"
                    />
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12" v-if="this.billing_type === 'AZIENDA'">
                                <div class="form-group">
                                    <input type="text" class="form-control"
                                           :placeholder="$t('account.reg_soc')+' *'"
                                           v-model="form.ragione_sociale">
                                </div>
                            </div>
                            <div class="col-md-6" v-if="this.billing_type === 'AZIENDA'">
                                <div class="form-group">
                                    <input type="text" maxlength="20" class="form-control"
                                           :placeholder="$t('piva')+' *'" v-model="form.p_iva"/>
                                </div>
                            </div>
                            <div
                                :class="{'col-md-6':this.billing_type === 'AZIENDA', 'col-md-12':this.billing_type === 'PRIVATO'}">
                                <div class="form-group">
                                    <input type="text" maxlength="20" class="form-control"
                                           :placeholder="$t('cod_fisc')+' *'"
                                           v-model="form.cod_fisc"/>
                                </div>
                            </div>
                            <div class="col-sm-8">
                                <div class="form-group">
                                    <input type="text" class="form-control"
                                           :placeholder="$t('account.via')+' *'"
                                           v-model="form.indirizzo"/>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <input type="text" class="form-control"
                                           :placeholder="$t('account.civico')+' *'"
                                           v-model="form.numero"/>
                                </div>
                            </div>
                            <div class="col-sm-8">
                                <div class="form-group">
                                    <input type="text" class="form-control"
                                           :placeholder="$t('account.citta')+' *'"
                                           v-model="form.localita_citta"/>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <input type="text" class="form-control"
                                           :placeholder="$t('account.cap')+' *'"
                                           v-model="form.cap_citta"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control"
                                           :placeholder="$t('account.prv')+' *'"
                                           :maxlength="this.province_length"
                                           v-model="form.provincia"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <select v-model="form.nazione" class="form-control" @change="truncateProvince">
                                        <option value="">{{$t('account.sel_country')}}</option>
                                        <option v-for="country in this.countries"
                                                :value="country.iso">
                                            {{country.traduzione_ll.nome}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6" v-if="this.billing_type === 'AZIENDA'">
                                <div class="form-group">
                                    <input v-model="form.sdi"
                                           type="text" class="form-control" placeholder="SDI">
                                </div>
                            </div>
                            <div class="col-md-6" v-if="this.billing_type === 'AZIENDA'">
                                <div class="form-group">
                                    <input v-model="form.pec"
                                           type="text" class="form-control" placeholder="PEC">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12" v-if="this.user_authenticated">
                        <div class="form-group">
                            <mcw-checkbox v-model="f_salva">
                                &nbsp; {{$t('save_into_my_data')}}
                            </mcw-checkbox>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div slot="footer" class="d-flex flex-fill justify-content-between">
            <button type="button" class="btn btn-default w-auto" @click="$emit('close')">
                {{$t('btn_annulla')}}
            </button>
            <button type="button" class="btn btn-primary w-auto" @click="submit()" :disabled="this.loading">
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" v-if="this.loading"></span>
                {{$t('btn_salva')}}
            </button>
        </div>
    </modal>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {newBillingAddress} from '../../../api/account';

import Modal from '../../partials/Modal';

export default {
    name: "ModalBillingAddress",
    components: {Modal},
    props: ['billingAddress', 'countries'],
    data() {
        return {
            form: {
                ragione_sociale: this.billingAddress ? this.billingAddress.ragione_sociale : '',
                cod_fisc: this.billingAddress ? this.billingAddress.cod_fisc : '',
                p_iva: this.billingAddress ? this.billingAddress.p_iva : '',
                indirizzo: this.billingAddress ? this.billingAddress.indirizzo : '',
                numero: this.billingAddress ? this.billingAddress.numero : '',
                localita_citta: this.billingAddress ? this.billingAddress.localita_citta : '',
                cap_citta: this.billingAddress ? this.billingAddress.cap_citta : '',
                provincia: this.billingAddress ? this.billingAddress.provincia : '',
                nazione: this.billingAddress ? this.billingAddress.nazione : '',
                sdi: this.billingAddress ? this.billingAddress.sdi : '',
                pec: this.billingAddress ? this.billingAddress.pec : '',
            },
            billing_type: this.billingAddress ? this.billingAddress.fatturazione_tipo : 'PRIVATO',
            f_salva: false,
            loading: false,
            errors: []
        }
    },
    created() {
        if (!this.form.nazione) {
            this.form.nazione = this.locale.stato;
        }
        if (!this.locale.f_fat_obbligatoria) {
            this.billing_type = 'AZIENDA';
        }

    },
    computed: {
        province_length: function () {
            if (this.form.nazione === 'IT') {
                return 2
            }

            return null;
        },
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('auth', {
            user: state => state
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale
        }),
        ...mapGetters('auth', {
            user_authenticated: 'authenticated'
        }),
    },
    methods: {
        truncateProvince: function () {
            if (this.province_length) {
                this.form.provincia = this.form.provincia.substr(0, this.province_length);
            }
        },
        submit: function () {
            this.loading = true;

            let address = {...this.form};
            address.fatturazione_tipo = this.billing_type;

            newBillingAddress(this.language, {
                api_key: this.user.api_key,
                id_ristorante: this.id_ristorante,
                f_salva: this.f_salva,
                ...address
            }).then(() => {
                this.$emit('close', address);
            }).catch(({messages}) => {
                this.errors = messages;
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>
